import { trimTypeConstants } from "../../constants";
import { trimTypeService } from "../../services";
import { alertActions } from "../alert.actions";

export const trimTypeActions = {
  getSingleParameter,
  getAllParameters,
  addParameter,
  updateParameter,
  deleteParameter,
  clear,
};

// get single parameter
function getSingleParameter() {}

// get all parameter
function getAllParameters() {
  return (dispatch) => {
    dispatch(request());

    trimTypeService.getAllParameters().then(
      (items) => dispatch(success(items)),
      (error) => dispatch(failure(error))
    );
  };

  function request(params) {
    return { type: trimTypeConstants.GET_ALL_REQUEST, params };
  }
  function success(items) {
    return { type: trimTypeConstants.GET_ALL_SUCCESS, items };
  }
  function failure(error) {
    return { type: trimTypeConstants.GET_ALL_FAILURE, error };
  }
}

// add parameter
function addParameter(name, chinese_name, technical_name, status,color_ids) {
  return (dispatch) => {
    dispatch(request(name, chinese_name, technical_name, status,color_ids));

    trimTypeService.addParameter(name, chinese_name, technical_name, status,color_ids).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: trimTypeConstants.ADD_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: trimTypeConstants.ADD_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: trimTypeConstants.ADD_FAILURE, error };
  }
}

// update parameter
function updateParameter(id, name, chinese_name, technical_name, status,color_ids) {
  return (dispatch) => {
    dispatch(request(id, name, chinese_name, technical_name, status,color_ids));

    trimTypeService
      .updateParameter(id, name, chinese_name, technical_name, status,color_ids)
      .then(
        (parameter) => {
          dispatch(success(parameter));
          dispatch(alertActions.success(parameter));
        },
        (error) => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
        }
      );
  };

  function request(parameter) {
    return { type: trimTypeConstants.UPDATE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: trimTypeConstants.UPDATE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: trimTypeConstants.UPDATE_FAILURE, error };
  }
}

// delete parameter
function deleteParameter(id) {
  return (dispatch) => {
    dispatch(request(id));

    trimTypeService.deleteParameter(id).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: trimTypeConstants.DELETE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: trimTypeConstants.DELETE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: trimTypeConstants.DELETE_FAILURE, error };
  }
}

// clear parameter
function clear() {
  return { type: trimTypeConstants.CLEAR };
}
